export const environment = {
  production: true,
  isFacebookLoginDisabled: false,
  redirectUrl: 'http://bestdriveportal.hu',
  testGuard: false,
  insiteUrl: '',
  insiteSkUrl: '',
};
